import { Link } from "react-router-dom";
import React from "react";
import PageSeo from "../../components/seo/PageSeo";
import { useTranslation } from "react-i18next";
import "./thanks.css";

/* PAIEMENT RÉUSSI — design "Signal" */
const ThankYou = () => {
  const { t } = useTranslation();

  return (
    <div className="sg-page" style={{ maxWidth: 520, minHeight: "60vh", justifyContent: "center" }}>
      <PageSeo noindex title={t("signal.pay-ok-title")} />
      <div className="sg-panel" style={{ padding: 32, textAlign: "center" }}>
        <span
          style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 52, height: 52, borderRadius: "50%",
            background: "var(--color-success-soft)", color: "var(--color-success)",
            font: "700 24px/1 var(--font-display)", marginBottom: 14,
          }}
        >
          ✓
        </span>
        <h1 className="sg-h1" style={{ fontSize: 22, marginBottom: 8 }}>
          {t("overview.payment-succ")}
        </h1>
        <p className="sg-sub" style={{ fontSize: 14, marginBottom: 20 }}>
          {t("overview.ty-des")}
        </p>
        <Link to="/" className="sg-btn sg-btn--primary">
          {t("overview.home-page")}
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
